import _ from 'lodash';
import { createTranslator } from 'next-intl';
import messagesEn from '../locales/en.json';
import messagesNl from '../locales/nl.json';

export const tEn = createTranslator({
  messages: messagesEn,
  locale: 'en',
  getMessageFallback: ({ key }) => _.get(messagesEn, key)
});

export const t = createTranslator({
  messages: messagesNl as unknown as IntlMessages,
  locale: 'nl',
  getMessageFallback: ({ key }) => _.get(messagesEn, key)
});
